import {combineReducers} from 'redux';
import * as actions from './actions';

const baskets = (prevBaskets = [], action) => {
    switch (action.type) {
        case actions.ACTION_RECEIVE_GAME_INFO:
            return action.gameInfo.baskets.map(b => ({...b, active: false}));
        case actions.ACTION_SET_RESULT:
            return prevBaskets.map((basket) => {
                if (basket.id !== action.basketId || action.result === 0) {
                    return basket;
                }
                const newBasket = {...basket};

                newBasket.results = newBasket.results.map((result) => {
                    const newResult = result;
                    if (result.team === action.teamId) {
                        newResult.result = action.result;
                        newResult.ob = action.ob;
                    }
                    return newResult;
                });

                return newBasket;
            });
        case actions.ACTION_ACTIVATE_BASKET_BY_DIRECTION: {
            const nextBaskets = [];
            let nextActiveIndex = null;

            for (let idx = 0; idx < prevBaskets.length; idx += 1) {
                /*
                 - Mark all baskets as not active.
                 - Find current active basket, based on that, calculate and save the index of the next active basket
                 to the variable `nextActiveIndex`
                 */
                if (action.currentBasketId === prevBaskets[idx].id) {
                    /*
                     If currentBasket is the first one and you try to activate previous basket OR
                     currentBasket is the last one and you try to activate the next basket, then mark the currentBasket
                     as the next active basket. Otherwise mark the desired basket as active.
                     */

                    if (idx + action.direction < prevBaskets.length && (idx + action.direction >= 0)) {
                        nextActiveIndex = idx + action.direction;
                    } else {
                        nextActiveIndex = idx;
                    }
                }
                nextBaskets.push({...prevBaskets[idx], active: false});
            }
            // Activate the basket at `nextActiveIndex`
            nextBaskets[nextActiveIndex].active = true;
            return nextBaskets;
        }

        default:
            return prevBaskets;
    }
};

const teams = (prevTeams = [], action) => {
    switch (action.type) {
        case actions.ACTION_RECEIVE_GAME_INFO:
            return [...action.gameInfo.teams.sort(t => t.id).map(t => ({...t, active: false}))];
        case actions.ACTION_ACTIVATE_NEXT_TEAM: {
            const nextTeams = [];
            let activateNext = false;

            for (let idx = 0; idx < prevTeams.length; idx += 1) {
                if (activateNext) {
                    nextTeams.push({...prevTeams[idx], active: true});
                    activateNext = false;
                } else if (prevTeams[idx].id === action.currentTeamId) {
                    if (idx < prevTeams.length - 1) {
                        nextTeams.push({...prevTeams[idx], active: false});
                        activateNext = true;
                    } else {
                        nextTeams.push({...prevTeams[idx], active: true});
                    }
                } else {
                    nextTeams.push({...prevTeams[idx], active: false});
                }
            }
            return nextTeams;
        }
        case actions.ACTION_ACTIVATE_FIRST_TEAM: {
            const nextTeams = [];
            for (let idx = 0; idx < prevTeams.length; idx += 1) {
                let shouldBeActive = false;
                if (idx === 0) {
                    shouldBeActive = true;
                }
                nextTeams.push({...prevTeams[idx], active: shouldBeActive});
            }
            return nextTeams;
        }
        case actions.ACTION_ACTIVATE_TEAM:
            return prevTeams.map((t) => {
                if (t.id === action.teamId) {
                    return {...t, active: true};
                }
                return {...t, active: false};
            });
        default:
            return prevTeams;
    }
};

const gameId = (prevGameId = null, action) => {
    switch (action.type) {
        case actions.ACTION_RECEIVE_GAME_INFO:
            return action.gameInfo.id;
        default:
            return prevGameId;
    }
};

const resultEntryReducer = combineReducers({
    teams,
    baskets,
    gameId,
});

export default resultEntryReducer;



// WEBPACK FOOTER //
// ./src/apps/result_entry/reducers.js